import * as React from 'react';

import { Button, SearchField } from '@rematter/ui-web';
import { useAtom } from 'jotai';
import { LucideX } from 'lucide-react';

import * as state from '../../_state/salesOrdersList.state';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { SelectFacility } from '~/shared/components/select-fields/SelectFacility';
import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

//
// ⚛️ ⚛️ ⚛️ SALES ORDER FILTERS ⚛️ ⚛️ ⚛️
//
export const SalesOrderFilters = () => {
  const t = useTranslations();

  // Atoms
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);
  const [selectedFacility, setSelectedFacility] = useAtom(
    state.$selectedFacility,
  );

  // Memoized values
  const hasActiveFilters = React.useMemo(
    () =>
      (searchTerm !== undefined && searchTerm?.trim() !== '') ||
      (selectedFacility !== undefined && selectedFacility !== 'all'),
    [searchTerm, selectedFacility],
  );

  // Callbacks
  const handleClearAll = React.useCallback(() => {
    setSearchTerm('');
    setSelectedFacility(undefined);
  }, [setSearchTerm, setSelectedFacility]);

  return (
    <>
      <SearchField
        autoFocus
        placeholder={t.salesOrdersView.filters.search.placeholder}
        aria-label={t.salesOrdersView.filters.search.placeholder}
        value={searchTerm}
        className="w-[200px] shrink-0"
        onChange={(value) => setSearchTerm(value ?? '')}
      />
      <SelectFacility
        value={selectedFacility ?? 'all'}
        onChange={(value) => setSelectedFacility(value ?? 'all')}
        showAllOption
        allOptionLabel={'All Facilities'}
        className="w-[200px] shrink-0"
      />
      {hasActiveFilters && (
        <Button
          variant="text"
          color="primary"
          icon={<LucideX />}
          onPress={handleClearAll}
        >
          {t.salesOrdersView.filters.clearAll}
        </Button>
      )}
    </>
  );
};
